import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { cleanupLegacyServiceWorker } from "@/lib/serviceWorkerCleanup";

// Module scope runs exactly once per page load (never per render, so React
// StrictMode's double-invoke can't repeat it), and the cleanup never
// reloads the page — see serviceWorkerCleanup.js.
cleanupLegacyServiceWorker();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
